import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import ProcessSection from "@/components/landing/ProcessSection";
import ProcessTimeline from "@/components/landing/ProcessTimeline";
import QualificationSection from "@/components/landing/QualificationSection";
import NewsletterSubscription from "@/components/layout/NewsletterSubscription";
import ScrollReveal from "@/components/ScrollReveal";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Process = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <main>
        {/* Hero Section */}
        <section className="section-spacing bg-gradient-to-b from-background to-primary/5">
          <div className="container mx-auto px-4 lg:px-8">
            <ScrollReveal delay={100}>
              <div className="text-center mb-12 lg:mb-16">
                <h1 className="text-4xl sm:text-5xl lg:text-7xl font-display font-bold mb-6 lg:mb-8">
                  Our <span className="bg-gradient-brand bg-clip-text text-transparent">Proven Process</span>
                </h1>
                <p className="text-xl lg:text-2xl text-muted-foreground max-w-4xl mx-auto leading-relaxed">
                  From agency dependency to content ownership in 90 days. Here's exactly how we transform your content operations into a self-sustaining growth engine.
                </p>
              </div>
            </ScrollReveal>
          </div>
        </section>

        <ScrollReveal delay={100}>
          <ProcessSection />
        </ScrollReveal>
        
        <ScrollReveal delay={200}>
          <ProcessTimeline />
        </ScrollReveal>
        
        <ScrollReveal delay={300}>
          <QualificationSection />
        </ScrollReveal>
        {/* Final CTA Section */}
        <section className="section-spacing bg-gradient-to-br from-background via-primary/10 to-accent/10">
          <div className="container px-4 lg:px-8">
            <ScrollReveal>
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="text-3xl lg:text-5xl font-display font-bold mb-8 bg-gradient-brand bg-clip-text text-transparent">
                  Ready to Build Your Content Capability?
                </h2>
                
                <p className="text-xl lg:text-2xl text-muted-foreground mb-12 leading-relaxed">
                  Let's discuss how our philosophy and methodology can help you transform from content-dependent to content-autonomous in 90 days.
                </p>
                
                <Link to="/contact">
                  <Button 
                    variant="hero" 
                    size="xl" 
                    className="text-lg lg:text-xl px-12 lg:px-16 py-6 lg:py-8 min-h-[64px] lg:min-h-[72px] animate-glow-pulse shadow-2xl font-black tracking-wide"
                  >
                    <span className="relative z-10">🚀 START THE CONVERSATION</span>
                  </Button>
                </Link>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
      <NewsletterSubscription />
      <Footer />
    </div>
  );
};

export default Process;